import { Zip } from "./Zip"

export const RecordCreate = <T>(
  keys: string[],
  values: T[]
): Record<string, T> => Object.fromEntries(Zip(keys, values))
